// Text normalization (same as RN version)
const normalizeText = (text: string) => text.toLowerCase().trim()

export interface ReferenceColorType {
  donutChartRefColor: string
  lineChartRefColor: string
  avatarBGRefColor: [string, string, ...string[]] | string
  buttonIconRefColor: string
  buttonBGRefColor: string
  sendRequestBGRefColor: [string, string, ...string[]] | string
  sendRequestStartGradient?: [number, number]
  sendRequestEndGradient?: [number, number]
}

const defaultDollarReferenceColors: ReferenceColorType = {
  avatarBGRefColor: '#33CC67',
  donutChartRefColor: '#70FFA1',
  buttonIconRefColor: '#70FFA1',
  buttonBGRefColor: 'rgba(25, 151, 98, 0.20)',
  lineChartRefColor: '#70FFA1',
  sendRequestBGRefColor: '#00CF46',
}

export const getReferenceColorsForTheCurrency = ({
  currencyCode,
}: {
  currencyCode: string
}): ReferenceColorType => {
  const currencyCodeHandled = normalizeText(currencyCode)

  switch (currencyCodeHandled) {
    case 'usdt':
      return defaultDollarReferenceColors

    case 'usd':
      return defaultDollarReferenceColors

    case 'kwdk':
      return {
        avatarBGRefColor: '#0051A0',
        donutChartRefColor: '#0051A0',
        buttonIconRefColor: '#0381FC',
        buttonBGRefColor: 'rgba(0, 117, 230, 0.20)',
        lineChartRefColor: '#0051A0',
        sendRequestBGRefColor: '#0051A0',
      }

    case 'aedk':
      return {
        avatarBGRefColor: '#000000',
        donutChartRefColor: '#000000',
        buttonIconRefColor: '#FFF',
        buttonBGRefColor: '#232425',
        lineChartRefColor: '#5F6163',
        sendRequestBGRefColor: '#000000',
      }

    case 'sark':
      return {
        avatarBGRefColor: '#005430',
        donutChartRefColor: '#005430',
        buttonIconRefColor: '#00DD7F',
        buttonBGRefColor: 'rgba(0, 221, 127, 0.20)',
        lineChartRefColor: '#005430',
        sendRequestBGRefColor: '#005430',
      }

    case 'btc':
      return {
        avatarBGRefColor: '#F7931A',
        donutChartRefColor: '#F7931A',
        buttonIconRefColor: '#F7931A',
        buttonBGRefColor: 'rgba(247, 147, 26, 0.20)',
        lineChartRefColor: '#F7931A',
        sendRequestBGRefColor: '#F7931A',
      }

    case 'eth':
      return {
        avatarBGRefColor: '#7059FF',
        donutChartRefColor: '#7361FF',
        buttonIconRefColor: '#958CFF',
        buttonBGRefColor: 'rgba(149, 140, 255, 0.20)',
        lineChartRefColor: '#685CFF',
        sendRequestBGRefColor: '#7059FF',
      }

    case 'xaut':
      return {
        avatarBGRefColor: ['#FCFBE7', '#FFD475', '#DD8536'],
        donutChartRefColor: '#D8B35D',
        buttonIconRefColor: '#D8B35D',
        buttonBGRefColor: 'rgba(216, 179, 93, 0.20)',
        lineChartRefColor: '#F7D14E',
        sendRequestBGRefColor: ['#F7D14E', '#D4A041'],
        sendRequestStartGradient: [0, 0],
        sendRequestEndGradient: [1, 0],
      }

    case 'sol':
      return {
        avatarBGRefColor: '#000000',
        donutChartRefColor: '#000000',
        buttonIconRefColor: '#AC59FF',
        buttonBGRefColor: 'rgba(144, 89, 255, 0.20)',
        lineChartRefColor: '#AC59FF',
        sendRequestBGRefColor: ['#41FFD1', '#534FFF'],
        sendRequestStartGradient: [0.7, 0],
        sendRequestEndGradient: [0.9, 1],
      }

    default:
      return {
        avatarBGRefColor: '#5F6163',
        donutChartRefColor: '#5F6163',
        buttonIconRefColor: '#FFF',
        buttonBGRefColor: '#5F6163',
        lineChartRefColor: '#5F6163',
        sendRequestBGRefColor: '#5F6163',
      }
  }
}
